/* global axios */
import ApiClient from './ApiClient';

class LinkPreviewApi extends ApiClient {
  constructor() {
    super('link_preview', { accountScoped: true });
  }

  show(url) {
    return axios.get(this.url, { params: { url } });
  }
}

export default new LinkPreviewApi();
